import {
  GET_API, POST_API,
} from "../../Functionalities/APIs";
import {
  accountsAllAccountsUrl,
  accountsBranchBalanceUrl,
  accountsTransactionsUrl,
  accountsAccountsUrl,
} from "../../Constants/apiUrls";

export const ManageRestaurantReports = async (e, data, keyword, params) => {
  let function_name = "RestaurantReports";
  // void 0
  let path = accountsAllAccountsUrl;
  if (keyword == "get") {
    // void 0
    let result = GET_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageSeperateRestaurantReport = async (e, data, keyword, params) => {
  // alert('helo')
  let function_name = "RestaurantSeperateReport"
  let path = accountsBranchBalanceUrl;
  if (keyword == "get") {
    let result = GET_API("", params, path);
    return await result.then((result) => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
}

export const ManageOrderReports = async (e, data, keyword, params) => {
  let function_name = "OrderReports";
  // void 0
  let path = accountsTransactionsUrl;
  if (keyword == "get") {
    // void 0
    let result = GET_API("", params, path);
    return await result.then((result) => {
      // void 0
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageOrderReportsNew = async (e, data, keyword, params) => {
  let function_name = "OrderReports";
  // void 0
  let path = accountsAccountsUrl;
  if (keyword == "get") {
    // void 0

    let result = GET_API("", params, path);
    return await result.then((result) => {
      // void 0
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }
  if (keyword == "add") {
    //alert("Add worked");
    
    var fdata = new FormData();

    fdata.append("transaction_list", data.transaction_list);
    fdata.append("keyword", data.keyword);
    // fdata.append("branch_name",data.branch_name)
    fdata.append("status", data.status);

    let result = POST_API(fdata, "", path);

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};
